import { BoxesResponse } from './';

export type BoxesEntry = {
  workerId: string;
  detections: BoxesResponse[];
  time?: number;
};

export type RegressionEntry = {
  workerId: string;
  detections: number[];
  time?: number;
};

export type TrackEntry = BoxesEntry | RegressionEntry;
